import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { combineLatest, map, of, switchMap } from 'rxjs';

import { LoggerService } from '../services/logger.service';

export const X_TRANSACTION_ID_HEADER = 'X-Transaction-Id';

/**
 * HTTP interceptor to had a header to requests to the backend for
 * tracking/troubleshooting purposes.
 * @param req HTTP request
 * @param next nest handler
 * @returns the modified request
 */
export const transactionIdInterceptor: HttpInterceptorFn = (req, next) => {
  const loggerService = inject(LoggerService);

  return combineLatest([loggerService.configuration$, of(req)]).pipe(
    map(([config, request]) => {
      const clone = request.clone({
        headers:
          config.transactionId && !req.url.includes('.svg')
            ? request.headers.set(X_TRANSACTION_ID_HEADER, config.transactionId)
            : request.headers,
      });
      return next(clone);
    }),
    switchMap((request) => request),
  );
};
